import React, { useState, useEffect } from 'react';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import HelpIcon from '@material-ui/icons/HelpOutline';
import IconButton from '@material-ui/core/IconButton';
import BookmarkIcon from '@material-ui/icons/StarBorder';
import NewNoteIcon from '@material-ui/icons/NoteAdd';
import BugIcon from '@material-ui/icons/BugReport';
import EditNoteIcon from '@material-ui/icons/Description';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { makeStyles } from '@material-ui/styles';
import { connect } from 'react-redux';
import { addBookmark, getNotes, addRecentNote } from '../../redux/actions';
import Note from '../Notes/Note';
import NoteListModal from '../Notes/NoteListModal';
import HelpModal from '../HelpModal';
import ReportError from '../ReportError';

const useStyles = makeStyles(theme => ({
  menuItem: {
    color: 'rgba(0, 0, 0, 0.54)',
    fontWeight: 500,
    '& svg': {
      marginRight: 15,
    }
  },
  recentNotes: {
    listStyleType: 'none',
    color: 'rgba(0, 0, 0, 0.54)',
    padding: 0,
    '& > li': {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      width: 230,
      cursor: 'pointer',
      padding: '6px 20px',
      '&:hover': {
        background: '#eee',
        color: '#333',
      }
    }
  },
}));

function ActionMenu (props) {
  const classes = useStyles();
  const [ anchorEl, setAnchorEl ] = useState(null);
  const [ note, setNote ] = useState({ open: false, title: '', content: '' });
  const [ noteListOpen, setNoteListOpen ] = useState(false);
  const [ helpOpen, setHelpOpen ] = useState(false);
  const [ reportError, setReportError ] = useState(false);

  useEffect(() => {
    if (props.notes.length === 0) props.getNotes();
    // eslint-disable-next-line
  }, []);

  const actionMnuShow = ev => {
    ev.stopPropagation();
    setAnchorEl(ev.currentTarget);
  }

  const actionMnuClose = ev => {
    ev.stopPropagation();
    setAnchorEl(null);
  }

  const help = ev => {
    actionMnuClose(ev);
    setHelpOpen(true);
  }

  const openReportError = ev => {
    actionMnuClose(ev);
    setReportError(true);
  }

  const addBookmark = ev => {
    const { title, link } = props.bookmark;
    actionMnuClose(ev);
    props.addBookmark(title, link);
  }

  const addNote = ev => {
    actionMnuClose(ev);
    setNote({ open: true, title: '', content: '' });
  }

  const hideNote = () => {
    setNote({ open: false });
  }

  const editNote = ev => {
    actionMnuClose(ev);
    setNoteListOpen(true);
  }

  const openNote = (ev, note) => {
    actionMnuClose(ev);
    const { id, title, content } = note;
    setNote({ id, open: true, title, content });
    props.addRecentNote(id);
  }

  const renderRecentNotes = () => {
    const { notes } = props;
    if (!notes || notes.length === 0 || !props.recentNotes || props.recentNotes.length === 0) return '';
    return (
      <ul className={classes.recentNotes}>
        {props.recentNotes.map(noteId => {
          const note = notes.find(note => note.id === noteId);
          if(note) return <li key={noteId} onClick={ev => openNote(ev, note)}>{note.title}</li>
          return '';
        })}
      </ul>
    );
  }

  return(
    <>
    <div onClick={ev => {ev.preventDefault()}}>
      <IconButton onClick={actionMnuShow}>
        <MoreVertIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={actionMnuClose}
      >
      <MenuItem onClick={help} className={classes.menuItem}><HelpIcon /> Pomoc</MenuItem>
      <MenuItem onClick={addBookmark} className={classes.menuItem}><BookmarkIcon /> Dodaj do zakładek</MenuItem>
      <MenuItem onClick={addNote} className={classes.menuItem}><NewNoteIcon /> Dodaj notatkę</MenuItem>
      <MenuItem onClick={editNote} className={classes.menuItem}><EditNoteIcon /> Edytuj notatkę</MenuItem>
      <MenuItem className={classes.menuItem} onClick={openReportError}><BugIcon /> Zgłoś błąd</MenuItem>
      {props.recentNotes && props.recentNotes.length !== 0 && props.recentNotes[0] !== null &&<hr />}
      {renderRecentNotes()}
    </Menu>
    </div>
    {note.open && <Note note={note} hide={hideNote}/>}
    {noteListOpen && <NoteListModal
      open={noteListOpen}
      close={setNoteListOpen}
      notes={props.notes}
      setNote={setNote}
      addRecentNote={props.addRecentNote}
    />}
    {helpOpen && <HelpModal close={setHelpOpen} options={props.options}/>}
    {reportError && <ReportError close={setReportError} href={window.location.href}/>}
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    notes: state.notes,
    recentNotes: state.userState.recentNotes,
  }
}

export default connect(mapStateToProps, { addBookmark, getNotes, addRecentNote })(ActionMenu);